import { render, staticRenderFns } from "./CompanyInfoDialog.vue?vue&type=template&id=822649d2&"
import script from "./CompanyInfoDialog.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoDialog.vue?vue&type=style&index=0&id=822649d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports